import { render, staticRenderFns } from "./ReceiversBlacklistComponent.vue?vue&type=template&id=499dffb6"
import script from "./ReceiversBlacklistComponent.vue?vue&type=script&lang=js"
export * from "./ReceiversBlacklistComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports